// Special case for nudges that need to show after a navigation.
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { ACCOUNT_ID, KEY_HAS_NAVIGATED_FROM_LINK } from '../../../common/constants.tsx';
import { localStorageProvider } from '../../../common/utils/local-storage.tsx';
import type { State } from '../../model/types.tsx';
import { setHasNudgeActive } from '../set-has-nudge-active/index.tsx';

export const nextShouldShowNudgeAfterNavigation =
	(taskId: string): Action<State> =>
	({ dispatch }) => {
		const nudgeToShowAfterNavigationKeyPair = {
			accountId: ACCOUNT_ID,
			key: KEY_HAS_NAVIGATED_FROM_LINK,
		};

		const shouldShowNudge =
			localStorageProvider().get(nudgeToShowAfterNavigationKeyPair) === taskId;

		if (shouldShowNudge) {
			dispatch(setHasNudgeActive(true));
			localStorageProvider().remove(nudgeToShowAfterNavigationKeyPair);
		}
	};
